export enum IssueSeverity {
  critical = 'critical',
  high = 'high',
  medium = 'medium',
  low = 'low',
  informational = 'informational',
}

export enum IssueStatus {
  open = 'open',
  resolved = 'resolved',
}

export enum IssueTaxonomy {
  dataExfiltration = 'dataExfiltration',
  destructiveAction = 'destructiveAction',
  breakingAttempts = 'breakingAttempts',
}

export enum IssueSource {
  soc_agent = 'soc_agent',
  security_scanner = 'security_scanner',
  manual_review = 'manual_review',
  automated_detection = 'automated_detection',
  threat_intelligence = 'threat_intelligence',
  user_report = 'user_report',
}

export enum IssueEventType {
  findingAdded = 'findingAdded',
  stepTaken = 'stepTaken',
  statusChanged = 'statusChanged',
  severityUpdated = 'severityUpdated',
  assignmentChanged = 'assignmentChanged',
  commentAdded = 'commentAdded',
  remediationApplied = 'remediationApplied',
  violationAdded = 'violationAdded',
  resource_updated = 'resourceUpdated',
  escalated = 'escalated',
}

export enum IssueEventOrigin {
  run_time = 'run_time',
  scheduled_scan = 'scheduled_scan',
  manual_action = 'manual_action',
  api_call = 'api_call',
  system_update = 'system_update',
  external_integration = 'external_integration',
}
